export default "__VITE_ASSET__DWiUPjvW__"